<template>
    <div class="container-fluid">
        <template v-for="articleGroup in articles">
            <div class="row with-gutters--2 mb-3">
                <div v-for="(article, index) in articleGroup" :class="columnClasses(articleGroup, index)"
                     class="d-flex align-items-end">
                    <div class="w-100 h-auto position-relative">
                        <img :src="article.thumbnail" class="w-100 h-auto" alt="">
                        <stamp v-if="article.stamp" class="news-stamp stamp--overlay bg-transparent spot-text"></stamp>
                    </div>
                </div>
            </div>
            <div class="row with-gutters--2 mb-5">
                <div v-for="(article, index) in articleGroup" :class="columnClasses(articleGroup, index)">
                    <news-article :article="article"></news-article>
                </div>
            </div>
        </template>
    </div>

</template>

<script>
    import NewsArticle from "./news-article";
    import Stamp from '../components/stamp/Stamp';

    export default {
        components: { NewsArticle, Stamp },
        props: {
            articles: {
                type: Array,
                required: true,
            },
            columnsPerItem: {
                type: Number,
                required: true,
            },
            maxColumns: {
                type: Number,
                required: true,
            }
        },
        methods: {

            columnClasses (group, index) {
                let num = 12;

                if (!group[index].featured) {
                    if (index === group.length - 1) {
                        num = 12 - ((index) * this.columnsPerItem);
                        num = Math.min(this.maxColumns, num); // make sure that elements are not taking whole grid if they are not featured and there is a max size
                    } else {
                        num = this.columnsPerItem;
                    }
                }

                return `col-${num}`;
            }
        },
    }
</script>
